import { useTranslation } from '@msdk/common'
import { FormNode, OptionsetValue } from '@msdk/definitions'
import { FormControlLabel, Switch } from '@msdk/ui'
import React from 'react'

import { useFieldValue } from '../../hooks'
import { ChangeArgs } from '../../models/form'

interface Props {
  node: FormNode
  onChange: (args: ChangeArgs) => void
  multiselect: boolean
  setMultiselect: (value: boolean) => void
  disabled?: boolean
}

// eslint-disable-next-line import/no-unused-modules
export function BinnedItems(props: Props) {
  const t = useTranslation()
  const [value, setValue] = useFieldValue(props.node, props.onChange)

  const handleToggle = (e: any, checked: boolean) => {
    const innerVal = checked ? 'INACTIVE' : 'ACTIVE'
    const newValue = new OptionsetValue(innerVal, 'ENTITY_STATUS')
    props.node.value.isDirty = true
    setValue(newValue)
  }

  const isChecked = () => {
    return !!(value && value.value === 'INACTIVE')
  }

  return (
    <FormControlLabel
      label={t('LBL_STATUS_FIL', 'Binned items')}
      control={<Switch disabled={props.disabled} checked={isChecked()} onChange={handleToggle} />}
    />
  )
}
